/**
 * ชื่อพนักงานสำหรับแสดงผล — "ชื่อ นามสกุล (ชื่อเล่น)" ทุกจุดในแอป.
 * ยกเว้น: สลิปเงินเดือน/สลิปจ่ายนอกรอบ (PDF) + เอกสารราชการ/ไฟล์ธนาคาร
 * ใช้ชื่อจริงล้วน (จัดการฝั่ง worker — ห้ามใช้ helper นี้กับเอกสารพวกนั้น).
 */
export interface NamedEmp {
  first_name?: string | null;
  last_name?: string | null;
  nickname?: string | null;
}

export function empName(e: NamedEmp | null | undefined, fallback = ''): string {
  if (!e) return fallback;
  const full = `${e.first_name ?? ''} ${e.last_name ?? ''}`.trim() || fallback;
  return e.nickname ? `${full} (${e.nickname})` : full;
}
